// Angular
import { Injectable } from '@angular/core';

// Capacitor
import { Capacitor } from '@capacitor/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { FilePicker } from '@capawesome/capacitor-file-picker';

// Third party
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CameraService {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private dataIdSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  dataId$ = this.dataIdSubject.asObservable();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private dataBillSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  dataBill$ = this.dataBillSubject.asObservable();

  constructor() { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sendIdData(data: any) {
    this.dataIdSubject.next( data );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sendBillData(data: any) {
    this.dataIdSubject.next( data );
  }

  async takePicture() {

    if(Capacitor.getPlatform() != 'web') await Camera.requestPermissions();
    return Camera.getPhoto({
      quality: 40,
      // allowEditing: false,
      source: CameraSource.Camera,
      resultType: CameraResultType.DataUrl
    }).then((image) => {

      // const blob = this.dataURLtoBlob(image.dataUrl);
      return {
        base64: image.dataUrl,
        base64cut: image.dataUrl?.split(',')[1],
        format: image.format,
        // size: blob.size | 0,
        size: this.convertToAtob(image.dataUrl?.split(',')[1]),
        field: '',
        invalidFileSize: false
      };

    }).catch(err => {
      // console.error('Error taking photo', err);
      return null;
    });

  }

  async uploadDocument() {

    return FilePicker.pickFiles({
      types: ['image/png', 'image/jpg', 'image/jpeg', 'image/svg+xml'],
      multiple: false,
      readData: true
    }).then(async(files) => {

      const f = files;
      const file = f.files[0];

      const fileBlob = this.dataURItoBlob(file.data);
      // file.blob
      const rawFile = new File([fileBlob as BlobPart], file.name, {
        type: file.mimeType,
      });

      // const image = await this.convertFileToBase64(rawFile);
      const image = await this.convertFileToBase64(rawFile);

      return {
        fileName: file.name,
        base64: image,
        base64cut: file.data,
        // base64cut: image.split(',')[1],
        format: file.mimeType,
        size: this.convertToAtob(image.split(',')[1]),
        field: '',
        invalidFileSize: false
      };

    }).catch(err => {
      // console.error('Error taking photo', err);
      return null;
    });

  }

  // async uploadDocument() {

  //   if(Capacitor.getPlatform() != 'web') await Camera.requestPermissions();
  //   return Camera.getPhoto({
  //     quality: 40,
  //     allowEditing: false,
  //     source: CameraSource.Photos,
  //     resultType: CameraResultType.DataUrl
  //   }).then((image) => {

  //     // const blob = this.dataURLtoBlob(image.dataUrl);
  //     return {
  //       base64: image.dataUrl,
  //       base64cut: image.dataUrl?.split(',')[1],
  //       format: image.format,
  //       // size: blob.size | 0,
  //       size: this.convertToAtob(image.dataUrl?.split(',')[1]),
  //       field: '',
  //       invalidFileSize: false
  //     };

  //   }).catch(err => {
  //     console.error('Error taking photo', err);
  //     return null;
  //   });

  // }

  private convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private dataURItoBlob(dataURI: any) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'mime' });
    return blob;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // private dataURLtoBlob(dataurl: any) {
  //   const arr = dataurl.split(',');
  //   const mime = arr[0].match(/:(.*?);/)[1];
  //   const bstr = atob(arr[1]);
  //   let n = bstr.length;
  //   const u8arr = new Uint8Array(n);

  //   while(n--){
  //       u8arr[n] = bstr.charCodeAt(n);
  //   }

  //   return new Blob([u8arr], {type:mime});
  // }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private convertToAtob(base64: any) {
    // Convert the Base64 string into binary data
    const binaryString = atob(base64);

    // Calculate the size of the binary data
    const fileSizeInBytes = binaryString.length;

    // If you want to convert bytes to other units like KB or MB, you can do so like this:
    // const fileSizeInKB = fileSizeInBytes / 1024;
    // const fileSizeInMB = fileSizeInKB / 1024;

    return (fileSizeInBytes / (1024 * 1024));
  }

  // try {
  //   const capturedPhoto = await Camera.getPhoto({
  //     quality: 100,
  //     allowEditing: false,
  //     resultType: CameraResultType.Uri,
  //     source: CameraSource.Camera
  //   });

  //   return capturedPhoto.webPath;
  // } catch (error) {
  //   console.error('Error taking photo', error);
  //   return null;
  // }

}
